module.exports = __webpack_public_path__ + "img/智能门店轻松管理-pc.494a1638.png";